// extracted by mini-css-extract-plugin
export var container = "_ao-0";
export var containerTopRight = "_ao-1";